import { createContext } from 'react';

import { ModalSize } from '../index';
type ModalContextValue = { size: keyof typeof ModalSize };

export const ModalContext = createContext<ModalContextValue>({ size: 'DEFAULT' });
